;(function () {
  var infType = {
    UNKNOWN: 'Unknown',
    IOS: 'iOS',
    ANDROID: 'Android',
  }

  window.INTERFACE_TYPE = infType

  window.Native = {}

  /**
   * OS, Device 정보
   * @returns
   */
  var navigator = function () {
    var userAgent = window.navigator.userAgent.toLowerCase()
    return {
      os: function (os) {
        if (os === undefined) {
          return this.device().os
        }
        return this.device(os)
      },
      device: function (os, version) {
        console.log('hybrid', 'user agent : ' + userAgent)
        var result
        if (os === undefined) {
          result = { os: 'unknown', version: '', tablet: false, mobile: false }

          if (userAgent.match(/android/i)) {
            result.os = 'Android'
            if (!userAgent.match(/mobile/i)) {
              result.tablet = true
            }
            version = /Android ([\\.\\_\d]+)/i.exec(userAgent)
            result.version = version ? version[1] : ''
            result.mobile = true
          } else if (userAgent.match(/iphone|ipad/i)) {
            console.log('hybrid', 'called ios!!!!!')
            result.os = 'iOS'
            if (userAgent.match(/ipad/i)) {
              result.tablet = true
            }
            version = /OS (\d+)_(\d+)_?(\d+)?/i.exec(window.navigator.appVersion)
            if (version) {
              result.version = version[1] + '.' + version[2] + '.' + (version[3] | 0)
            }
            result.mobile = true
            console.log('hybrid', 'iOS version : ' + result.version)
          }
          return result
        }

        result = this.device()
        // var os = result.os.match(new RegExp(os, "i")) ? true : false;
        os = result.os.match(new RegExp(os, 'i')) ? true : false
        if (version === undefined) {
          return os
        }
        var ver = result.version.match(new RegExp(version, 'i')) ? true : false
        return os && ver
      },
      inApp: function () {
        if (userAgent.match(/FSMNS_HYBRID_APP/i)) return true
        else return false
      },
    }
  }
  window.Native.navigator = new navigator()

  /**
   * Native interface platform 반환
   * @return "UNKNOWN" or "IOS" or "ANDROID"
   */
  window.Native.interfaceType = (function () {
    var type = infType.UNKNOWN

    if (window.Native.navigator.device('ios')) {
      type = infType.IOS
    } else if (window.Native.navigator.device('android')) {
      type = infType.ANDROID
    }

    return type
  })()

  const generateRandom = function () {
    // A buffer with just the right size to convert to Float64
    let buffer = new ArrayBuffer(8)

    // View it as an Int8Array and fill it with 8 random ints
    let ints = new Int8Array(buffer)
    window.crypto.getRandomValues(ints)

    // Set the sign (ints[7][7]) to 0 and the
    // exponent (ints[7][6]-[6][5]) to just the right size
    // (all ones except for the highest bit)
    ints[7] = 63
    ints[6] |= 0xf0

    // Now view it as a Float64Array, and read the one float from it
    let float = new DataView(buffer).getFloat64(0, true) - 1

    return float
  }

  window.Native.callbackId = generateRandom()
  window.Native.callbacks = {}

  /**
   * Native->js 호출(async)
   *
   * @param {*} callbackId 	js에서 관리되는 callback id
   * @param {*} args 				전달받을 결과값(항상 json format)
   */
  window.Native.nativeCallback = function (callbackId, args) {
    var callback = window.Native.callbacks[callbackId]
    if (callback) {
      callback.apply(null, [args])
      // delete window.Native.callbacks[callbackId];
    }
  }

  /**
   * js->Native 함수 호출
   * @param {*} funcName 	호출된 native 함수명(ios일 경우에는 handler name)
   * @param {*} params 		항상 json format
   * @param {*} callback 	async 처리 시 값 전달받을 함수
   * @returns
   */
  window.Native.execute = function (bridgeName, funcName, params, callback) {
    if (window.Native.navigator.inApp() == false) {
      const errMsg = 'The requested function will only work on the native app.\nRun it in the native app.'
      const errResult = {
        errorMessage: errMsg,
      }

      console.log('native-bridge', errMsg)

      return JSON.stringify(errResult)
    }

    // parameter 없을 경우
    if (arguments.length === 0) {
      console.log('The parameter does not exist. Enter at least a function name.')
      return
    }

    if (!bridgeName) bridgeName = 'hybrid'

    // 함수 이름이 문자열이 아닐 경우
    if (typeof funcName !== 'string') {
      console.log('Enter the function name as string.')
      return
    }

    var isAsync = false
    var isParam = true
    var callbackId = null
    // callback이 존재할 경우 callback id 증가
    if (typeof callback == 'function') {
      isAsync = true
      callbackId = window.Native.callbackId
      const prevCallback = window.Native.callbacks[callbackId]
      if (prevCallback) delete window.Native.callbacks[callbackId]
      else window.Native.callbackId += 1

      window.Native.callbacks[callbackId] = callback
    }

    if (typeof params === undefined || params == null) {
      isParam = false
    }

    // iOS
    if (window.Native.interfaceType === infType.IOS) {
      var message = {}

      // 비동기
      if (isAsync) {
        if (isParam)
          message = { callbackId: callbackId.toString(), bridgeName: bridgeName, funcName: funcName, params: params }
        else message = { callbackId: callbackId.toString(), bridgeName: bridgeName, funcName: funcName }

        // window.webkit.messageHandlers[funcName].postMessage(JSON.stringify(message));
        window.webkit.messageHandlers[bridgeName].postMessage(JSON.stringify(message))
      }
      // 동기
      else {
        if (isParam) {
          if (typeof params !== 'object' && typeof params !== 'string') params = params.toString()
          message = { bridgeName: bridgeName, funcName: funcName, params: params }
        } else message = { bridgeName: bridgeName, funcName: funcName }
        return prompt(JSON.stringify(message))
      }
    }
    // Android
    else if (window.Native.interfaceType === infType.ANDROID) {
      if (isParam) {
        if (typeof params === 'object') params = JSON.stringify(params)
        else if (typeof params !== 'string') params = params.toString()
      }

      // 비동기
      if (isAsync) {
        if (isParam) window[bridgeName][funcName](callbackId.toString(), params)
        else window[bridgeName][funcName](callbackId.toString())
      }
      // 동기
      else {
        if (isParam) {
          return window[bridgeName][funcName](params)
        } else {
          return window[bridgeName][funcName]()
        }
      }
    } else {
      if (isAsync) {
        window.Native.nativeCallback(callbackId, {})
      } else {
        return ''
      }
    }
  }

  /**
   * Plugin 실행
   * @param {*} bridgeName Native 코드 설계를 위한 대분류
   * @param {*} funcName
   * @param {*} params
   * @param {*} callback
   */
  window.Native.plugin = function (bridgeName, funcName, params, callback) {
    return window.Native.execute(bridgeName, funcName, params, callback)
  }
})()
